import React, { useContext } from "react";
import "./ReprocessModal.scss";
import WarningIcon from "../../../VectorIcons/WarningIcon";
import { Box, Button, Typography } from "@mui/material";
import { RecommendationsAPIContext } from "../../../../context/RecommendationsAPI/recommendationsAPIContext";
import SimpleScriptBox from "../../../../views/ProjectSheet/SimpleScriptBox/SimpleScriptBox";

export function ReprocessModal({ open, title }) {
  const { setCloseModal, setChangeModal } = useContext(
    RecommendationsAPIContext
  );

  const cancelButtonStyles = {
    backgroundColor: "#EC1045",
    color: "#FFF",
    textTransform: "none",
    fontWeight: 700,
    fontSize: "16px",
    padding: "8px 24px",
    borderRadius: "4px",
    fontFamily: "inherit",

    "&:hover": {
      backgroundColor: "#D80F3E",
    },

    "&:disabled": {
      opacity: 0.5,
      cursor: "not-allowed",
      color: "#FFF",
    },
  };

  const continueButtonStyles = {
    backgroundColor: "#009C69",
    color: "#FFF",
    textTransform: "none",
    fontWeight: 700,
    fontSize: "16px",
    padding: "8px 24px",
    borderRadius: "4px",
    fontFamily: "inherit",

    "&:hover": {
      backgroundColor: "#00885f",
    },

    "&:disabled": {
      opacity: 0.5,
      cursor: "not-allowed",
      color: "#FFF",
    },
  };

  return (
    <SimpleScriptBox
      open={open}
      title={title}
      icon={<WarningIcon color="#FFF" />}
      className="reprocess-modal"
      size="large"
      removePadding={true}
      allowOverflow={true}
      toggleScriptBox={() => setCloseModal()}
    >
      <Box sx={{ backgroundColor: "#FFF" }}>
        <Box sx={{ padding: "24px 64px" }}>
          <Typography
            sx={{
              fontFamily: "inherit",
              fontWeight: 700,
              textAlign: "center",
              textTransform: "uppercase",
              color: "#EC1045",
              marginBottom: "12px",
              fontSize: "14px",
            }}
          >
            Atenção
          </Typography>

          <Typography sx={{ fontFamily: "inherit", fontSize: "16px" }}>
            {`Este conteúdo já possui tramas preenchidas. Ao utilizar a função de
          IA, as tramas atuais serão apagadas e substituídas automaticamente
          pelas novas tramas detectadas pela ferramenta.`}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            padding: "16px 24px",
            gap: "0 24px",
            boxShadow: "rgba(0, 0, 0, 0.2) 0px 5px 20px",
          }}
        >
          <Button onClick={() => setCloseModal()} sx={cancelButtonStyles}>
            Cancelar
          </Button>

          <Button
            onClick={() => setChangeModal({ changeTo: "SELECTOR-MODAL" })}
            sx={continueButtonStyles}
          >
            Continuar
          </Button>
        </Box>
      </Box>
    </SimpleScriptBox>
  );
}
